// extracted by mini-css-extract-plugin
export var boldText = "_41-4";
export var checkboxContainer = "_41-6";
export var closeIcon = "_41-g";
export var container = "_41-0";
export var drawer = "_41-8";
export var drawerContent = "_41-9";
export var extraSmallText = "_41-5";
export var fulfillmentGroupTable = "_41-e";
export var largeText = "_41-3";
export var loadingSpinnerContainer = "_41-h";
export var mediumText = "_41-2";
export var narrow = "_41-f";
export var notificationLink = "_41-j";
export var packageCheckIconContainer = "_41-7";
export var slideoutHeaderContainer = "_41-a";
export var slideoutModal = "_41-c";
export var stickyHeaderWrapper = "_41-b";
export var table = "_41-i";
export var tableContainer = "_41-d";
export var tertiaryText = "_41-1";